// extracted by mini-css-extract-plugin
export default {"button":"styles_button__zDfSi","normal":"styles_normal__VH9+D","small":"styles_small__85XrZ"};